module.exports = __webpack_public_path__ + "images/emoji/light_rail.07ebf402c7efef45d177.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/light_rail.png
// module id = BG2u
// module chunks = 2